import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=51f8f2ab&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"
import style0 from "./Modal.vue?vue&type=style&index=0&id=51f8f2ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f8f2ab",
  null
  
)

export default component.exports